import { requestDatasetAction } from '../../../api/requests/dataset/requestDatasetAction';
import {
  DatasetControlMethodActionApiRequestData,
  SubsetControlMethodActionApiRequestData,
} from '../../../api/types/types';
import { apiRequest } from '../../../api/utils/apiRequest';
import { detailedApiMethodFetcher } from '../../../api/utils/fetchers/detailedApiMethodFetcher';
import {
  DatasetControl,
  DetailedApiMethod,
  MethodControlAction,
  SimpleApiMethod,
} from '../../../types/types';
import { ResponseActionHandler } from '../../../types/context';
import { resolveTemplate } from '../../../utils/json/resolveTemplate';
import { CustomJsonataFunctions } from '../../../utils/json/resolveStringExpression';
import useApiErrorHandling from '../../useApiErrorHandling';
import { executeWithForceRetry } from './executeWithForceRetry';

export const getMethodApiCallback = (
  control: DatasetControl,
  token: string | null,
  requestData:
    | DatasetControlMethodActionApiRequestData
    | SubsetControlMethodActionApiRequestData,
  refetchData: () => void,
  handleApiError: ReturnType<typeof useApiErrorHandling>,
  getResponseActionHandler?: (
    name: string
  ) => ResponseActionHandler | undefined,
  customFunctions?: CustomJsonataFunctions
) => {
  return async () => {
    const retypedControlAction = control.action as MethodControlAction;

    // String api method request flow — no responseActions support, auto-reload on success.
    if (
      control.action.type === 'method' &&
      typeof retypedControlAction.apiMethod === 'string'
    ) {
      const { apiUrl } = await resolveTemplate(
        { apiUrl: control.action.apiMethod },
        requestData,
        customFunctions
      );

      await executeWithForceRetry(
        (forceHeader) =>
          requestDatasetAction(
            apiUrl as SimpleApiMethod,
            'GET',
            token,
            forceHeader
          ),
        handleApiError,
        refetchData
      );
      return;
    }

    // Detailed api method request flow — reload is opt-in via responseActions.reload.
    await executeWithForceRetry(
      (forceHeader) =>
        apiRequest(
          retypedControlAction.apiMethod as DetailedApiMethod,
          requestData,
          (apiMethod) => detailedApiMethodFetcher(apiMethod, forceHeader),
          getResponseActionHandler,
          customFunctions
        ),
      handleApiError
    );
  };
};
